import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { CommentRatingProps } from "models/propTypes/commentViewPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { SupportRatingState } from "models/enums/support";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { RatingBinary, RatingResponse } from "components/common";
import { useSupportService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CommentRating: React.FC<React.PropsWithChildren<CommentRatingProps>> = (props) => {
  const supportService = useSupportService();
  const [supportRatingState, setSupportRatingState] = React.useState<SupportRatingState>(
    props.feedbackWasSubmitted ? SupportRatingState.UnknownRating : SupportRatingState.NotRated
  );

  const submitRating = (id: number, rating: number) => {
    const ratingObject: WintSuperkollAPIModel.SupportCommentRatingPost = {
      rating,
    };
    supportService.submitCommentRating(id, ratingObject);
    props.onSubmitFeedback && props.onSubmitFeedback();
  };

  const onRatingButtonClick = (rating: boolean) => {
    submitRating(props.targetId, rating ? 1 : 0);
    setSupportRatingState(rating ? SupportRatingState.PositiveRated : SupportRatingState.NegativeRated);
  };

  return (
    <Grid item container justifyContent="center">
      {supportRatingState === SupportRatingState.NotRated ? (
        <RatingBinary onRatingClick={onRatingButtonClick} />
      ) : supportRatingState === SupportRatingState.PositiveRated ? (
        <RatingResponse
          messageTitle={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SupportIssue.RatingResponseTitlePositive
          )}
          messageBody={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SupportIssue.RatingResponseTextPositive
          )}
        />
      ) : supportRatingState === SupportRatingState.NegativeRated ? (
        <RatingResponse
          messageTitle={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SupportIssue.RatingResponseTitleNegative
          )}
          messageBody={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SupportIssue.RatingResponseTextNegative
          )}
        />
      ) : (
        <RatingResponse
          messageTitle={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SupportIssue.RatingResponseTitleNeutral
          )}
          messageBody={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SupportIssue.RatingResponseTextNeutral
          )}
        />
      )}
    </Grid>
  );
};

export default CommentRating;
